import React from 'react';
import { withUser } from '../../../../user/UserContext';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../../components/modal/components/modal-restricted/withRestrictedModal';
import { Connect, PropsFromRedux } from '../SortContainer';
import { searchConstants } from '../../../search-utils/searchConstants';
import { SortItem } from './SortItem';
import { doctrineAnalytics } from '../../../../utils/analyticsUtils';
import { SortTypes } from '../../../search.types';
import { UserContextType } from '../../../../user/user.types';

type Props = { onClick: Function } & PropsFromRedux &
  WithRestrictedModalProps &
  UserContextType;

export class RawSortList extends React.Component<Props> {
  static defaultProps = {
    onClick: () => {},
  };

  changeSortClicked = (type: SortTypes) => () => {
    const {
      accessPremium,
      onSortUpdate,
      openRestrictedModal,
      onClick,
    } = this.props;
    if (!accessPremium) {
      openRestrictedModal(searchConstants.sorts[type].event);
    } else {
      doctrineAnalytics('Search FilterSortClicked', { sort: type });
      onSortUpdate(type);
      onClick();
    }
  };

  render() {
    const { selectedSort, displayCommentariesSearch } = this.props;
    return (
      <>
        <SortItem
          isSelected={selectedSort === 'relevance'}
          type="relevance"
          handleClick={this.changeSortClicked}
        />
        <SortItem
          isSelected={selectedSort === 'chrono'}
          type="chrono"
          handleClick={this.changeSortClicked}
        />
        <SortItem
          isSelected={selectedSort === 'antiChrono'}
          type="antiChrono"
          handleClick={this.changeSortClicked}
        />
        {displayCommentariesSearch && (
          <SortItem
            isSelected={selectedSort === 'commented'}
            type="commented"
            handleClick={this.changeSortClicked}
          />
        )}
      </>
    );
  }
}

export const SortList = withUser(withRestrictedModal(Connect(RawSortList)));
